let api

// http://localhost:5000/api

// if (process.env.NODE_ENV === "development") {
//     api = "http://13.126.168.253:5000/api"
//     // api = "http://localhost:5000/api"
// } else {
//     api = "https://crmbackend.vibhohcm.com/api"
// }
// api = "http://13.126.168.253:5000/api"
// api = "https://crmbackend.vibhohcm.com/api"
// api = "http://localhost:6002/api"
// api = "http://65.0.157.186:6002/api"
api = "https://agrofarms-backend.vibhohcm.com/api"
    // api = "https://crmbackend.staging.vibhohcm.com/api"
export default api

